<script setup lang="ts">
import { ModalDefault } from '@shared/ui/modals'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import { useModalTutorBillingErase } from '../../model/modal-tutor-billing-erase.hook'
import TutorBillingModalHeader from '../TutorBillingModalHeader.vue'
import TutorBillingFieldsTable from '../TutorBillingFieldsTable.vue'

defineOptions({
  name: 'ModalTutorBillingErase',
})

const {
  isOpen,
  isSaving,
  columns,
  rows,
  setKeep,
  setErase,
} = useModalTutorBillingErase()
</script>

<template>
  <ModalDefault
    :show="isOpen"
    :loading="isSaving"
    class-name="modal-tutor-billing-erase"
    is-close-button
    @click:overlay="setKeep"
    @click:close="setKeep"
  >
    <TutorBillingModalHeader
      title="Erase billing info?"
      subtitle="The record and payout history stay; all submitted values will be cleared. The tutor can fill in billing info again."
    />
    <TutorBillingFieldsTable
      :columns="columns"
      :rows="rows"
    />
    <template #controls>
      <BtnPrimary
        text="Erase"
        color="red"
        :disabled="isSaving"
        @click="setErase"
      />
      <BtnSecondary
        text="Keep as is"
        :disabled="isSaving"
        @click="setKeep"
      />
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalTutorBillingErase.scss" />
